<script setup lang="ts">

interface Props {
    title: string,
    loading: boolean
}

const props = defineProps<Props>();

const handleClick = (e: Event) => {
    if (props.loading) {
        e.stopImmediatePropagation()
    }
}
</script>

<template>
    <div @click.capture="handleClick">
        <div v-if="props.loading">
            <loader></loader>
        </div>
        <div v-else>
            <button type="button"
                    class="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                {{ props.title }}
            </button>
        </div>
    </div>
</template>

